import CollectionCancelEditModeButtonComponent from "./CollectionCancelEditModeButtonComponent";

export default CollectionCancelEditModeButtonComponent;